import client from "./sharedoClient"

const getOne = systemName => client.get(`api/admin/docGen/templates/${systemName}`);

const save = (systemName, contentBlock) => client.post(`api/admin/docGen/templates/${systemName}`, contentBlock)

const getSourceVersions = id => client.get(`api/admin/docGen/templates/sources/${id}/versions`);

export default {
    getOne,
    getSourceVersions,
    save
}